import React from 'react';

import {Group} from '@pb/kit-component-group';
import Typography from '@pb/kit-component-typography';

import {
    stepHeaderHeaderSeparator,
    stepHeaderSubHeader,
} from './step-header.module.styl';


type Props = {
    title: string,
    subTitle?: string,
};

export const StepHeader = ({title, subTitle}: Props) => {
    return (
        <Group alignItems="center">
            <Typography variant="heading-level-1">
                {title}
            </Typography>
            {subTitle ? (
                <Group alignItems="center">
                    <span className={stepHeaderHeaderSeparator}/>
                    <Group gap="s" className={stepHeaderSubHeader}>
                        {subTitle}
                    </Group>
                </Group>
            ) : null}
        </Group>
    );
};
